import { getTimestamp, now } from 'owa-datetime';

const cardShownTimes: Map<string, number> = new Map<string, number>();

export function markCardShown(id: string): void {
    if (!cardShownTimes.has(id)) {
        cardShownTimes.set(id, getTimestamp(now()));
    }
}

export function clearCardShownTime(id: string): void {
    cardShownTimes.delete(id);
}

export function consumeCardShownDuration(id: string): number | undefined {
    const shownAt = cardShownTimes.get(id);
    if (shownAt === undefined) {
        return undefined;
    }
    cardShownTimes.delete(id);
    return getTimestamp(now()) - shownAt;
}
